import ProcessNavigation from '@/components/process-navigation/index.vue';
import { mapGetters } from 'vuex';
import PublishPurchaseService from '../publish-purchase-service';
import { errorMessage } from '@/utils/message.js';
import Service from '@/service/index.js';

import { getValueByType } from '@/utils/common.js';

export default {
  components: {
    ProcessNavigation
  },
  data() {
    return {
      // processList: ['业务流程及准备材料', '编辑项目信息', '编辑意向供应人（投标人）资格要求', '上传附件信息', '确定承诺信息', '编辑采购文件', '提交申请'],
      id: '',
      oldId: '',
      isCreated: true,
      ruleForm: {
        bidderCondition: '',
        otherQualification: '',
        criminalRecord: '',
        promiseEnterprise: '',
        supplierDesc: [],
        purchaseType: ''
      },
      purchaseBudget: '', // 采购预算
      rules: {
        supplierDesc: [
          {required: true, message: '请选择意向投标人', trigger: 'change'}
        ],
        bidderCondition: [
          {required: true, message: '请输入对意向供应人（投标人）要求', trigger: 'blur'}
        ],
        criminalRecord: [
          {required: true, message: '请选择', trigger: 'change'}
        ],
        promiseEnterprise: [
          {required: true, message: '请选择', trigger: 'change'}
        ]
      },
      criminalRecord: null,
      promiseEnterprise: null,
      projectTypeOfPur: null,
      projectType: null
    };
  },
  computed: {
    ...mapGetters({
      processList: 'purchaseProcessList'
    })
  },
  created () {
    window.scrollTo(0, 0);
    this.id = this.$route.query.id;
    this.oldId = this.$route.query.oldId;
    this.projectTypeOfPur = this.$route.query.projectTypeOfPur;
    const arr = [
      ['criminalRecord', 'CRIMINAL_RECORD'], // 行贿记录
      ['promiseEnterprise', 'PROMISE_ENTERPRISE'] // 失信企业
    ];
    arr.forEach((value) => {
      if (!value.length) {
        return;
      }
      Service.getSelectList(value[1]).then(res => {
        if (res && res.code === '0') {
          res.data.forEach(item => item.disabled = false);
          this[value[0]] = res.data;
        }
      });
    });
    if (this.id) {
      this.getNewPurchaseInfo().then(() => {}, () => {
        if (this.oldId) {
          this.getOldPurchaseInfo();
        }
      });
    }
  },
  methods: {
    getValueByType,
    // 回显接口
    getNewPurchaseInfo () {
      return new Promise((resolve, reject) => {
        PublishPurchaseService.getPurchaseInfo({
          purchaseId: this.id,
          echoCode: 'PURCHASE'
        }).then(res => {
          this.projectType = res.data.projectType;
          if (!res.data || (res.data && !res.data.bidderCondition)) {
            reject();
          }
          this.purchaseBudget = res.data.purchaseBudget;
          // 采购预算> 500000时候， 默认选中1
          if(this.purchaseBudget > 500000) {
            this.criminalRecord.forEach(item => {
              item.disabled = true;
            });
            this.promiseEnterprise.forEach(item => {
              item.disabled = true;
            });
            this.ruleForm.criminalRecord = '1';
            this.ruleForm.promiseEnterprise = '1';
          }
          this.isCreated = false;
          Object.keys(this.ruleForm).forEach((key) => {
            if (res.data && res.data[key]) {
              this.ruleForm[key] = res.data && String(res.data[key]);
              if(key === 'supplierDesc') {
                this.ruleForm.supplierDesc = res.data[key].split(',');
              }
            }
          });
          resolve();
        });
      });
    },
    getOldPurchaseInfo () {
      return new Promise((resolve, reject) => {
        PublishPurchaseService.getPurchaseInfo({
          purchaseId: this.oldId,
          echoCode: 'PURCHASE'
        }).then(res => {
          if (!res.data || (res.data && !res.data.bidderCondition)) {
            reject();
          }
          this.purchaseBudget = res.data.purchaseBudget;
          // 采购预算> 500000时候， 默认选中1
          if(this.purchaseBudget > 500000) {
            this.criminalRecord.forEach(item => {
              item.disabled = true;
            });
            this.promiseEnterprise.forEach(item => {
              item.disabled = true;
            });
            this.ruleForm.criminalRecord = '1';
            this.ruleForm.promiseEnterprise = '1';
          }
          this.isCreated = true;
          Object.keys(this.ruleForm).forEach((key) => {
            if (res.data && res.data[key]) {
              this.ruleForm[key] = res.data && String(res.data[key]);
              if(key === 'supplierDesc') {
                this.ruleForm.supplierDesc = res.data[key].split(',');
              }
            }
          });
          resolve();
        });
      });
    },
    previousStep () {
      let str = '';
      if (this.id && this.oldId) {
        str = '&id=' + this.id + '&oldId=' + this.oldId;
      } else if (this.id) {
        str = '&id=' + this.id;
      } else {
        str = '&oldId=' + this.oldId;
      }+
      this.$router.replace('/publish-purchase/purchase-form?projectTypeOfPur=' + this.projectTypeOfPur + str);
    },
    next() {
      this.$refs['ruleForm'].validate(valid => {
        if (valid) {
          if (this.isCreated) {
            this.saveEligibilityForm();
          } else {
            this.updateEligibilityForm();
          }
        } else {
          return false;
        }
      });
    },
    saveEligibilityForm () {
      let params = JSON.parse(JSON.stringify(this.ruleForm));
      params.supplierDesc = params.supplierDesc.sort().join();

      PublishPurchaseService.saveEligibilityRequirementsInfo({
        purchaseId: this.id,
        ...params
      }).then(res => {
        if (res && res.code === '0') {
          if (this.oldId) {
            this.$router.push(`/publish-purchase/attachment-form?id=${this.id}&oldId=${this.oldId}&projectTypeOfPur=${this.projectTypeOfPur}&purchaseType=${this.ruleForm.purchaseType}`);
          } else {
            this.$router.push(`/publish-purchase/attachment-form?id=${this.id}&projectTypeOfPur=${this.projectTypeOfPur}&purchaseType=${this.ruleForm.purchaseType}`);
          }
        } else if (res && res.reason) {
          errorMessage(res && res.reason);
        } else {
          errorMessage('保存资格要求信息失败');
        }
      }, (error) => {
        if (error && error.data && error.data.reason) {
          errorMessage(error.data.reason);
        } else {
          errorMessage('保存资格要求信息失败');
        }
      });
    },
    updateEligibilityForm () {
      let params = JSON.parse(JSON.stringify(this.ruleForm));
      params.supplierDesc = params.supplierDesc.sort().join();
      PublishPurchaseService.updateEligibilityRequirementsInfo({
        purchaseId: this.id,
        ...params
      }).then(res => {
        if (res && res.code === '0') {
          if (this.oldId) {
            this.$router.push(`/publish-purchase/attachment-form?id=${this.id}&oldId=${this.oldId}&projectTypeOfPur=${this.projectTypeOfPur}&purchaseType=${this.ruleForm.purchaseType}`);
          } else {
            this.$router.push(`/publish-purchase/attachment-form?id=${this.id}&projectTypeOfPur=${this.projectTypeOfPur}&purchaseType=${this.ruleForm.purchaseType}`);
          }
        } else if (res && res.reason) {
          errorMessage(res && res.reason);
        } else {
          errorMessage('保存资格要求信息失败');
        }
      }, (error) => {
        if (error && error.data && error.data.reason) {
          errorMessage(error.data.reason);
        } else {
          errorMessage('保存资格要求信息失败');
        }
      });
    }
  }
};
